import React from "react";
import './dashboard.scss';
import { getImageSource } from "../../utility/image-source";
import { Constants, ImageConstants } from "../../constants/constants";
import SchoolApi from "../../apis/school";
import ClassEngagement from "./class-engagement/class-engagement";
import TeacherEngagementList from "./teacher-engagement-list/teacher-engagement-list";
import TeacherDashboardApi from "../../apis/teacher-dashboard";
import Loading from '../common/loading/loading';
import TeacherEngagementScore from "./teacher-engagement-score/teacher-engagement-score";
import StudentEngagementScoreLeaderBoard from "./student-engagement-score-leaderboard/student-engagement-score-leaderboard";
import Dropdown from '../common/dropdown-v2/dropdown';
import StudentScoreDetails from "./student-score-details/student-score-details";
import CommonUtils from "../../utility/common-utilities";
import ClickerFlowPractice from "../jigyasa-assessment/jigyasa-assessment";
import Quiz from "../quiz/quiz";
import ClassAssignmentDetails from '../engagement-report/class-assignment-details/class-assignment-details';
import SessionCache from "../routes/session-cache";
import { saveAs } from 'file-saver';
import Path from "../routes/routes-path";

const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

class TeacherDashboard extends React.Component {
    statusCard = [
        { title: "Assignments", value: 'CARD_1', cardIcon: getImageSource(ImageConstants.BLUE_SUITCASE_ICON), totalCount: 200, CompletedCount: 100 },
        { title: "Engagement Time", value: 'CARD_2', cardIcon: getImageSource(ImageConstants.BLUE_MENU_ICON), totalCount: 200, CompletedCount: 100 },
        { title: "Teacher Engagement", value: 'CARD_3', cardIcon: getImageSource(ImageConstants.RED_STUDENT_ICON), totalCount: 200, CompletedCount: 100 },
        { title: "Student Engagement", value: 'CARD_4', cardIcon: getImageSource(ImageConstants.GREEN_CIRCLE_ICON), totalCount: "200%", CompletedCount: 100 },

    ]

    state = {
        classes: [],
        teachersList: [],
        studentLeaderBoard: [],
        isLoading: false,
        selectedClass: '',
        boardsDropdownItems: [],
        classDropdownItems: [],
        teacherAssingmentOverview: [],
        selectedUserId: '',
        selectedSubjectId: '66a9d13f933e00065a431f07',
        selectedSubject: 'Maths'
    }

    accessRights = SessionCache.getAllowedModule()

    classWiseCompletionDetails = {}

    classSectionWiseCompletionDetails = {}

    componentDidMount() {
        // console.log('called teacher dashboard')
        this.toggleLayoutBar()
        if (CommonUtils.isOnline()) {
            let userInfo = SessionCache.getUser()
            // console.log(userInfo)

            if (userInfo.subjectId === Constants.SCIENCE_SUBJECTID) {
                this.setState({ selectedSubjectId: '66a9d14e933e00065a431f08', selectedSubject: 'Science' })
            }

            this.setState({ userInfo })

            this.getClasses()
        }
    }

    getSections() {

        let payload = {
            board: this.props.selectedBoard,
            class: this.props.selectedClass
        }

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                console.log(response)
                let sections = []
                for (let i = 0; i < response.response.length; i++) {

                    if (!response.response[i].noSectionInClass) {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                        })
                    }
                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "", unAssignedUsersCount: response.unAssignedUsers, noSectionInClassUsersCount: response.noSectionInClassUsersCount })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }


    toggleLayoutBar() {
        // console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        // this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        if(Constants.ELECTRON_BUILD) {
            window.electron.ipcRenderer.send('toggle-fullscreen', { fullscreen: false });
        }
        
        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }

    getClasses(payload = {}) {

        this.setState({ isLoading: true })

        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = []
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                let selectedBoard = boards[0].value
                this.setState({
                    classes, boards, selectedBoard,
                    classDropdownItems: classes, boardsDropdownItems: boards, reloadDropdown: true
                }, () => {
                    this.setState({ reloadDropdown: false })
                    this.getClassEngagementList()
                    this.getStaffs()
                    this.getStudentEngagementScoreRanking()
                    this.getClassAssignmentOverview()
                })
            }).catch(err => {
            })
    }


    onSelectSubject = (subjectName, subjectId) => {
        this.setState({ selectedSubject: subjectName, selectedSubjectId: subjectId }, () => {
            this.getClassEngagementList()
            this.getStaffs()
            this.getClassAssignmentOverview()
        })
    }



    getClassAssignmentOverview() {
        let payload = {
            board: this.state.selectedBoard
        }

        payload.selectedSubjectId = this.state.selectedSubjectId

        SchoolApi.getClassAssignmentOverview(payload).then(res => {
            console.log(res)
            this.classWiseCompletionDetails = res.classWiseDetails
            this.setState({ isLoading: false, teacherAssingmentOverview: res.teacherAssingmentOverview, pdfLink: res.pdfLink })
        }).catch(err => {
            console.log(err)
        })
    }

    getClassEngagementList() {

        let payload = {
            board: this.state.selectedBoard,
            selectedSubjectId: this.state.selectedSubjectId
        }
        this.setState({ isLoading: true })
        TeacherDashboardApi.getClassEngagementList(payload).then(res => {
            console.log(res);

            // this.classWiseCompletionDetails = res.classWiseDetails
            this.classSectionWiseCompletionDetails = res.classSectionWiseDetails
            this.setState({
                isLoading: false,
                totalCompletedAssignmentPercentage: res.totalCompletedAssignmentPercentage,
                totalAssignments: res.totalAssignments
            })

        }).catch(err => {
            console.log(err)
        })
    }

    getStaffs(payload = {}) {
        payload.types = `in/MATH_TEACHER,MATH_HOD`;
        payload.getClassDetails = true;
        payload.board = this.state.selectedBoard

        payload.selectedSubjectId = this.state.selectedSubjectId

        this.setState({ isLoading: true })
        SchoolApi.getStaffsWithEngagementScore(payload)
            .then(response => {
                this.setState({
                    teachersList: response?.response || [],
                    allTeacherTotalEngagementScore: response.allTeacherTotalEngagementScore, isLoading: false
                })
            }).catch(err => {
            })

    }



    getStudentEngagementScoreRanking() {
        let payload = {
            board: this.state.selectedBoard
        }

        if (this.state.selectedClass) {
            payload.class = this.state.selectedClass
        }
        this.setState({ isLoading: true })
        TeacherDashboardApi.getStudentEngagementScoreRanking(payload).then(res => {
            this.setState({
                studentLeaderBoard: res.studentLeaderBoard,
                totalStudentEngagementTime: res.totalEngagementTime,
                totalStudentEngagementScore: res.totalEngagementScore,
                isLoading: false
            })
        }).catch(err => {
            console.log(err)
        })
    }

    showClassEngagementList() {
        this.setState({ showClassEngagementList: true })
    }

    hideClassEngagement() {
        this.setState({ showClassEngagementList: false })
    }

    showTeacherEngagementList() {
        this.setState({ showTeacherEngagementList: true })
    }

    hideTeacherEngagementList() {
        this.setState({ showTeacherEngagementList: false })
    }

    showTeacherEngagementScore(item) {
        this.setState({ showTeacherEngagementScore: true, selectedItem: item })
    }

    hideTeacherEngagementScore() {
        this.setState({ showTeacherEngagementScore: false, selectedItem: '' })
    }

    showEngagementScoreLeaderBoard() {
        this.setState({ showEngagementScoreLeaderBoard: true })
    }

    hideEngagementScoreLeaderBoard() {
        this.setState({ showEngagementScoreLeaderBoard: false })
    }

    showStudentDetail(item) {
        this.setState({ showStudentDetail: true, selectedStudent: item })
    }

    hideStudentDetail() {
        this.setState({ showStudentDetail: false, selectedStudent: "" })
    }

    secondsToMinutesPipe(time) {
        if (!time) return 0

        if (time >= 60) {
            let mins = time / 60
            return `${Math.ceil(mins)} Mins`
        } else {
            return `${time} Sec`
        }
    }



    onSelectDropDown = (option, key) => {
        // console.log(option, key)
        this.setState({ [key]: option?.value, }, () => {
            if (key == "selectedClass") {
                this.getStudentEngagementScoreRanking()
            }

            if (key === "selectedBoard") {
                this.getClassEngagementList()
                this.getStaffs()
                this.getStudentEngagementScoreRanking()
                this.getClassAssignmentOverview()
            }
        })
    }


    getCurrentMonth() {
        const now = new Date();
        const monthName = monthNames[now.getMonth()];
        const year = now.getFullYear();

        return `(${monthName} ${year})`
    }

    getPreviousMonth() {
        const now = new Date();
        const prev = new Date(now.getFullYear(), now.getMonth() - 1);

        const prevMonthName = monthNames[prev.getMonth()];
        const prevYear = prev.getFullYear();
        return `(${prevMonthName} ${prevYear})`
    }

    getCurrentDate() {
        const now = new Date();
        const date = now.getDate();
        const monthName = monthNames[now.getMonth()];
        return `${date} ${monthName}`
    }

    getCurrentFiscalStartMonthYear() {
        const now = new Date();
        const fiscalStartYear = now.getMonth() < 3 ? now.getFullYear() - 1 : now.getFullYear();
        const fiscalStartMonth = 4; // April (1-based)
        return `(${monthNames[fiscalStartMonth - 1]} ${fiscalStartYear} to ${this.getCurrentDate()})`
    }

    showClassAssignmentDetails(className) {
        this.setState({ selectedClassName: className, showClassAssignmentDetails: true })
    }

    hideClassAssignmentDetails() {
        this.setState({ showClassAssignmentDetails: false, selectedClassName: false })
    }

    showTeacherAssignmentDetails(userId) {
        this.setState({ selectedUserId: userId, showTeacherAssignmentDetails: true })
    }

    hideTeacherAssignmentDetails(userId) {
        this.setState({ selectedUserId: "", showTeacherAssignmentDetails: false })
    }

    downloadPDF() {

        saveAs(this.state.pdfLink, `sara.pdf`)
    }

    navigateToPath(path) {
        this.props.history.push(path)
    }



    renderStudentLeaderBoard() {
        return (
            <div className="student-leaderboard-table">
                <table className="table table-bordered" style={{ border: 'none' }}>
                    <thead className="class-header">
                        <tr className="">
                            <th className="first-header-bg" colSpan="100%">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <img className="suit-case-image-size mr-1" src={getImageSource(ImageConstants.WHITE_SUITCASE_ICON)} />
                                        <span className="class-engagement-title">Student Leader Board (Top 10)</span>
                                    </div>
                                    <div className="d-flex">
                                        <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                                            {!this.state.reloadDropdown ?
                                                <Dropdown
                                                    placeholder='Select a Class'
                                                    options={this.state.classDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                    text={"title"}
                                                    value={this.state.selectedClass}

                                                /> : ''}
                                        </div>
                                        <div className="more-button-wrapper d-flex justify-content-center ml-2">
                                            <div className="more-button cursor-pointer" onClick={() => this.showEngagementScoreLeaderBoard()}>
                                                More
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </th>
                        </tr>
                        <tr className="second-header-bg">
                            <th className="" width='30%'>Student Name</th>
                            <th className="" width='10%'>Class</th>
                            <th width='10%'>Section</th>
                            <th width='10%'>Rank</th>
                            <th width='10%'>Engagement Score</th>
                        </tr>
                    </thead>
                    <tbody id="rows" className="class-body">
                        {
                            this.state.studentLeaderBoard && this.state.studentLeaderBoard.length ? this.state.studentLeaderBoard.map((item, index) => (
                                <>
                                    {
                                        index < 10 ? <tr>
                                            <td className="teacher-name">
                                                <div className="d-flex flex-wrap cursor-pointer" onClick={() => this.showStudentDetail(item)}>
                                                    {item.name}
                                                </div>
                                            </td>
                                            <td className="assignment-count">
                                                {item.class}
                                            </td>
                                            <td className="assignment-count">
                                                {item.section}
                                            </td>
                                            <td className="assignment-count">
                                                {item.rank}
                                            </td>
                                            <td className="assignment-count">
                                                {item.engagementScore}
                                            </td>
                                        </tr> : <></>
                                    }
                                </>

                            ))
                                :
                                <tr>
                                    <td colSpan="5" align='center'> No Records Found</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    renderClassAssignmentOverView(columnName) {
        return (
            <div className="student-leaderboard-table">
                <table className="table table-bordered" style={{ border: 'none' }}>
                    <thead className="class-header">
                        <tr className="">
                            <th className="first-header-bg" colSpan="100%">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <img className="suit-case-image-size mr-1" src={getImageSource(ImageConstants.CLASS_ASSIGNMENT)} />
                                        <span className="class-engagement-title">Class Assignments</span>
                                    </div>
                                </div>
                            </th>
                        </tr>

                        <tr className="section-header">
                            <th className="" style={{ backgroundColor: '#DDFFE9' }} >
                                <div className="d-flex justify-content-between">
                                </div>
                            </th>
                            <th className="" colSpan='75%' style={{ backgroundColor: '#FFEBCF' }}>
                                <div className="d-flex justify-content-center">
                                    <div className="d-flex align-items-center">
                                        {/* <img className="suit-case-image-size mr-1" src={getImageSource(ImageConstants.CLASS_ASSIGNMENT)} /> */}
                                        <span className="number-of-assignment-title">Number Of Assignments</span>
                                    </div>
                                </div>
                            </th>

                        </tr>
                        <tr className="second-header-bg">
                            <th className="" width='25%'>{columnName}</th>
                            <th className="" width='25%'>CM {this.getCurrentMonth()}</th>
                            <th width='25%'>PM {this.getPreviousMonth()}</th>
                            <th width='25%'>YTD {this.getCurrentFiscalStartMonthYear()}</th>
                            {/* <th width='10%'>Engagement Score</th> */}
                        </tr>
                    </thead>
                    <tbody id="rows" className="class-body">
                        {
                            this.state.classes && this.state.classes.length ? this.state.classes.map((item, index) => (
                                <>
                                    <tr >
                                        <td className={`class-text cursor-pointer ${this.state.classes.length - 1 === index ? 'border-bottom-left-radius' : ''}  `}
                                            onClick={() => this.showClassAssignmentDetails(item.title)}>
                                            {item.title}
                                        </td>
                                        <td className="assignment-count">
                                            {this.classWiseCompletionDetails[item.title] ? this.classWiseCompletionDetails[item.title].totalCurrentMonthAssignment : 0}
                                        </td>
                                        <td className="assignment-count">
                                            {`${this.classWiseCompletionDetails[item.title] ? this.classWiseCompletionDetails[item.title].totalPreviousMonthAssignment : 0}`}
                                        </td>
                                        <td className="assignment-count">
                                            {`${this.classWiseCompletionDetails[item.title] ? this.classWiseCompletionDetails[item.title].totalYTDAssignment : 0}`}
                                        </td>
                                    </tr>
                                </>

                            ))
                                :
                                <tr>
                                    <td colSpan="5" align='center'> No Records Found</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    renderTeacherAssignmentOverView(columnName) {
        return (
            <div className="student-leaderboard-table">
                <table className="table table-bordered" style={{ border: 'none' }}>
                    <thead className="class-header">
                        <tr className="">
                            <th className="first-header-bg" colSpan="100%">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <img className="suit-case-image-size mr-1" src={getImageSource(ImageConstants.TEACHER_ASSIGNMENT)} />
                                        <span className="class-engagement-title">Teacher Assignments</span>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr className="section-header">
                            <th className="" style={{ backgroundColor: '#DDFFE9' }} >
                                <div className="d-flex justify-content-between">
                                </div>
                            </th>
                            <th className="" colSpan='75%' style={{ backgroundColor: '#FFEBCF' }}>
                                <div className="d-flex justify-content-center">
                                    <div className="d-flex align-items-center">
                                        {/* <img className="suit-case-image-size mr-1" src={getImageSource(ImageConstants.CLASS_ASSIGNMENT)} /> */}
                                        <span className="number-of-assignment-title">Number Of Assignments</span>
                                    </div>
                                </div>
                            </th>

                        </tr>
                        <tr className="second-header-bg">
                            <th className="" width='25%'>{columnName}</th>
                            <th className="" width='25%'>CM {this.getCurrentMonth()}</th>
                            <th width='25%'>PM {this.getPreviousMonth()}</th>
                            <th width='25%'>YTD {this.getCurrentFiscalStartMonthYear()}</th>
                            {/* <th width='10%'>Engagement Score</th> */}
                        </tr>
                    </thead>
                    <tbody id="rows" className="class-body">
                        {
                            this.state.teacherAssingmentOverview && this.state.teacherAssingmentOverview.length ? this.state.teacherAssingmentOverview.map((item, index) => (
                                <>
                                    <tr>
                                        <td className={`class-text cursor-pointer ${this.state.classes.length - 1 === index ? 'border-bottom-left-radius' : ''}  `}
                                            onClick={() => this.showTeacherAssignmentDetails(item.userId)}>
                                            {item.staffName}
                                        </td>
                                        <td className="assignment-count">
                                            {item.currentMonthAssignment}
                                        </td>
                                        <td className="assignment-count">
                                            {`${item.previousMonthAssignment}`}
                                        </td>
                                        <td className="assignment-count">
                                            {`${item.yTDAssignment}`}
                                        </td>
                                    </tr>
                                </>

                            ))
                                :
                                <tr>
                                    <td colSpan="5" align='center'> No Records Found</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        if (this.state.showClassEngagementList) {
            return <ClassEngagement back={() => this.hideClassEngagement()}
                classList={this.state.classes}
                classWiseCompletionDetails={this.classWiseCompletionDetails}
                classSectionWiseCompletionDetails={this.classSectionWiseCompletionDetails} />
        }

        if (this.state.showTeacherEngagementList) {
            return <TeacherEngagementList back={() => this.hideTeacherEngagementList()} teachersList={this.state.teachersList} selectedBoard={this.state.selectedBoard} />
        }

        if (this.state.showTeacherEngagementScore) {
            return <TeacherEngagementScore back={() => this.hideTeacherEngagementScore()}
                selectedItem={this.state.selectedItem}
                selectedBoard={this.state.selectedBoard} />
        }

        if (this.state.showEngagementScoreLeaderBoard) {
            return <StudentEngagementScoreLeaderBoard back={() => this.hideEngagementScoreLeaderBoard()}
                studentLeaderBoard={this.state.studentLeaderBoard} />
        }

        if (this.state.showStudentDetail) {
            return <StudentScoreDetails back={() => this.hideStudentDetail()}
                selectedStudent={this.state.selectedStudent} />
        }

        if (this.state.showClassAssignmentDetails) {
            return (
                <ClassAssignmentDetails className={this.state.selectedClassName} board={this.state.selectedBoard}
                    back={() => this.hideClassAssignmentDetails()} isClassSectionWiseReport={true} />
            )
        }

        if (this.state.showTeacherAssignmentDetails) {
            return (
                <ClassAssignmentDetails userId={this.state.selectedUserId} board={this.state.selectedBoard}
                    back={() => this.hideTeacherAssignmentDetails()} isTeacherReport={true} />
            )
        }


        // if(!CommonUtils.isOnline()) {
        //     return <ClickerFlowPractice />
        // }

        // if (!CommonUtils.isOnline()) {
        //     return <Quiz />
        // }

        return (
            <div className="teacher-dashboard">
                {
                    this.state.isLoading ? <Loading /> :

                        Constants.ELECTRON_BUILD ?
                            <div className="electron-build-dashboard">
                                {
                                    !CommonUtils.isOnline() ? <></>
                                        :
                                        <div style={{ marginLeft: '-0.7rem' }}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="title">Class Snapshot</div>
                                                    {/* <div className="sub-title">Sub text here</div> */}
                                                </div>
                                                <div className="row student-leaderboard-class-filter mr-4">
                                                    {
                                                        this.state.boardsDropdownItems.length > 1 ?
                                                            <div className="col pt-4">
                                                                <div className="filter-input-label">
                                                                    Select Board<span className='text-danger'>*</span>
                                                                </div>
                                                                <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                                    <Dropdown
                                                                        placeholder='Select a board'
                                                                        options={this.state.boardsDropdownItems}
                                                                        onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                                        text={"title"}
                                                                        value={this.state.selectedBoard}

                                                                    />
                                                                </div>
                                                                {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                                            </div>
                                                            : ""
                                                    }
                                                </div>

                                            </div>
                                            <div className="status-cards d-flex mt-3">
                                                {/* {
                        this.statusCard.map(item => ( */}

                                                <div className="card-item">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <div className="card-title">{'Assignments'}</div>
                                                        <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.BLUE_SUITCASE_ICON)} /></div>
                                                    </div>
                                                    <div className="card-total-count">{this.state.totalAssignments?.toLocaleString()}</div>
                                                    <div className="mt-2">
                                                        <span className="completed-count">{this.state.totalCompletedAssignmentPercentage}%</span>
                                                        <span className="completed-text ml-1">Completed</span>
                                                    </div>
                                                </div>
                                                <div className="card-item">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <div className="card-title">{'Student Engagement Time'}</div>
                                                        <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.BLUE_MENU_ICON)} /></div>
                                                    </div>
                                                    <div className="card-total-count">{this.secondsToMinutesPipe(this.state.totalStudentEngagementTime)}</div>
                                                    {/* <div className="mt-2">
                            <span className="completed-count">{1}</span>
                            <span className="completed-text ml-1">Completed</span>
                        </div> */}
                                                </div>
                                                {/* <div className="card-item">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <div className="card-title">{'Teacher Engagement Score'}</div>
                                                <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.RED_STUDENT_ICON)} /></div>
                                            </div>
                                            <div className="card-total-count">{this.state.allTeacherTotalEngagementScore?.toLocaleString()}</div>
                                            
                                        </div> */}
                                                {/* <div className="card-item">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <div className="card-title">{'Student Engagement Score'}</div>
                                                <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.GREEN_CIRCLE_ICON)} /></div>
                                            </div>
                                            <div className="card-total-count">{this.state.totalStudentEngagementScore?.toLocaleString()}</div>

                                        </div> */}
                                                {/* ))
                    } */}
                                            </div>
                                        </div>
                                }


                                <div className="quick-actions-card">
                                    <div className="quick-actions-text title">
                                        Quick Actions
                                    </div>
                                    <div className="gray-divider"></div>
                                    <div className="d-flex">
                                        <div className="d-flex align-items-center action-cards" onClick={() => this.navigateToPath(Path.CLICKER_PRACTICE)}>
                                            <img className="action-image-size" src={getImageSource(ImageConstants.YEELOW_BULLET)} />
                                            <span>Practice</span>
                                        </div>
                                        <div className="d-flex align-items-center action-cards ml-4" onClick={() => this.navigateToPath(Path.CLICKER_ASSESSMENT)}>
                                            <img className="action-image-size" src={getImageSource(ImageConstants.YEELOW_BULLET)} />
                                            <span>Assessment</span>
                                        </div>
                                        {
                                            !CommonUtils.isOnline() ? <></>
                                                :
                                                <>
                                                    <div className="d-flex align-items-center action-cards ml-4" onClick={() => this.navigateToPath(Path.CONCEPT_CARDS)}>
                                                        <img className="action-image-size" src={getImageSource(ImageConstants.YEELOW_BULLET)} />
                                                        <span>Revise</span>
                                                    </div>
                                                    {
                                                        this.accessRights["CLICKER_REGISTRAION"] ?
                                                            <div className="d-flex align-items-center action-cards ml-4" onClick={() => this.navigateToPath(Path.ALL_SCHOOL_CLICKERS)}>
                                                                <img className="action-image-size" src={getImageSource(ImageConstants.YEELOW_BULLET)} />
                                                                <span>Clicker List</span>
                                                            </div>
                                                            :
                                                            <></>

                                                    }
                                                </>

                                        }


                                    </div>
                                </div>
                            </div>


                            :

                            <>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div className="title">School Dashboard</div>
                                        {/* <div className="sub-title">Sub text here</div> */}
                                    </div>
                                    <div className="row student-leaderboard-class-filter mr-4">
                                        {
                                            this.state.boardsDropdownItems.length > 1 ?
                                                <div className="col pt-4">
                                                    <div className="filter-input-label">
                                                        Select Board<span className='text-danger'>*</span>
                                                    </div>
                                                    <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                        <Dropdown
                                                            placeholder='Select a board'
                                                            options={this.state.boardsDropdownItems}
                                                            onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                            text={"title"}
                                                            value={this.state.selectedBoard}

                                                        />
                                                    </div>
                                                    {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                                </div>
                                                : ""
                                        }
                                    </div>
                                </div>
                                {/* <div className="d-flex justify-content-end align-items-center">
                                <div className="cursor-pointer" onClick={() => this.onSelectSubject('Maths', '66a9d13f933e00065a431f07')}>Maths</div>
                                <div className="ml-3 cursor-pointer" onClick={() => this.onSelectSubject('Science', '66a9d14e933e00065a431f08')}>Science</div>
                                <div className="ml-3 cursor-pointer" onClick={() => this.onSelectSubject('Both', '66a9d13f933e00065a431f07,66a9d14e933e00065a431f08')} >Both</div>
                            </div> */}

                                <div className="status-cards d-flex mt-3">
                                    {/* {
                        this.statusCard.map(item => ( */}

                                    <div className="card-item">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div className="card-title">{'Assignments'}</div>
                                            <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.BLUE_SUITCASE_ICON)} /></div>
                                        </div>
                                        <div className="card-total-count">{this.state.totalAssignments?.toLocaleString()}</div>
                                        <div className="mt-2">
                                            <span className="completed-count">{this.state.totalCompletedAssignmentPercentage}%</span>
                                            <span className="completed-text ml-1">Completed</span>
                                        </div>
                                    </div>
                                    <div className="card-item">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div className="card-title">{'Student Engagement Time'}</div>
                                            <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.BLUE_MENU_ICON)} /></div>
                                        </div>
                                        <div className="card-total-count">{this.secondsToMinutesPipe(this.state.totalStudentEngagementTime)}</div>
                                        {/* <div className="mt-2">
                            <span className="completed-count">{1}</span>
                            <span className="completed-text ml-1">Completed</span>
                        </div> */}
                                    </div>
                                    <div className="card-item">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div className="card-title">{'Teacher Engagement Score'}</div>
                                            <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.RED_STUDENT_ICON)} /></div>
                                        </div>
                                        <div className="card-total-count">{this.state.allTeacherTotalEngagementScore?.toLocaleString()}</div>
                                        {/* <div className="mt-2">
                            <span className="completed-count">{1}</span>
                            <span className="completed-text ml-1">Completed</span>
                        </div> */}
                                    </div>
                                    <div className="card-item">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div className="card-title">{'Student Engagement Score'}</div>
                                            <div className=""><img className="card-image-size" src={getImageSource(ImageConstants.GREEN_CIRCLE_ICON)} /></div>
                                        </div>
                                        <div className="card-total-count">{this.state.totalStudentEngagementScore?.toLocaleString()}</div>
                                        {/* <div className="mt-2">
                            <span className="completed-count">{1}</span>
                            <span className="completed-text ml-1">Completed</span>
                        </div> */}
                                    </div>

                                    {/* ))
                    } */}
                                </div>


                                <div className="class-engagement mt-4">
                                    <div className="engagement-report">
                                        <div className="d-flex justify-content-between align-items-center mr-4">
                                            <div className="header-subtext">{this.state?.userInfo?.schoolInfo?.name}</div>
                                            <div className="d-flex ">
                                                <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadPDF()}>Download Report</div>

                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {this.renderClassAssignmentOverView('Class')}
                                        </div>
                                        <div className="table-header-names">CM - Current Month, PM - Previous Month, YTD - YearToDate</div>
                                        <div className="mt-3">
                                            {this.renderTeacherAssignmentOverView('Teacher')}
                                        </div>
                                    </div>

                                </div>

                                <div className="student-leaderboard mt-4">

                                    {
                                        this.renderStudentLeaderBoard()
                                    }

                                </div>
                            </>
                }

            </div>
        )
    }

}

export default TeacherDashboard;